import { schema } from 'normalizr';

export const SubAttachmentSchema = new schema.Entity('attachments');

export const AttachmentSchema = new schema.Entity('attachments', {
  reportAttachments: [SubAttachmentSchema],
});

export const LocationSchema = new schema.Entity('locations');

export const ApplianceInformationSchema = new schema.Entity('applianceInformations', {
  reportAttachments: [AttachmentSchema],
});

export const LimitationSchema = new schema.Entity('limitations', {
  reportLocations: [LocationSchema],
  reportAttachments: [AttachmentSchema],
});

export const InformationSchema = new schema.Entity('informations', {
  reportLocations: [LocationSchema],
  reportAttachments: [AttachmentSchema],
  reportApplianceInformation: ApplianceInformationSchema,
});

export const OriginalDeficiencySchema = new schema.Entity('originalDeficiencies', {
  reportLocations: [LocationSchema],
  reportAttachments: [AttachmentSchema],
});

export const DeficiencySchema = new schema.Entity('deficiencies', {
  reportLocations: [LocationSchema],
  reportAttachments: [AttachmentSchema],
  originalReportDeficiency: OriginalDeficiencySchema,
});

export const SubsystemSchema = new schema.Entity('subsystems', {
  reportDeficiencies: [DeficiencySchema],
  reportInformations: [InformationSchema],
  reportLimitations: [LimitationSchema],
  reportAttachments: [AttachmentSchema],
});

export const SystemGroupSchema = new schema.Entity('systemGroups');

export const SystemSchema = new schema.Entity('systems', {
  reportSubsystems: [SubsystemSchema],
  reportAttachments: [AttachmentSchema],
});

export const InspectionScopeItemSchema = new schema.Entity('inspectionScopeItems');

export const InspectionSchema = new schema.Entity('inspections', {
  inspectionScopeItems: [InspectionScopeItemSchema],
});

export const InspectionReportsSchema = new schema.Entity('inspectionReports', {
  inspection: InspectionSchema,
});

export const ReportSchema = new schema.Entity('report', {
  inspectionReports: [InspectionReportsSchema],
  reportSystems: [SystemSchema],
  reportSystemGroups: [SystemGroupSchema],
});
